

import axios from 'axios'
import Vue from 'vue'
const BACKEND_URL = process.env.BACKEND_URL+"user/"

const user = new Vue ({
  beforeCreate(){
    axios.defaults.withCredentials = true;
  },
    methods : {
      getGuilds(){
          const url = BACKEND_URL + "guilds"
          return axios.get(url).then(response => response.data)
      },
    },
  })
  

  
  export default {
    install: function(Vue) {
      Vue.prototype.$user= user
    }
  }


// WEBPACK FOOTER //
// ./src/api/user.js